import React from 'react';
import { MessageType } from '../../../core/localization/model';
import { CallStatus } from '../../../models';
import { msgChecking, msgMoreLogsBtn } from '../../../modules/historical';
import { hasError } from '../../../utils/callStatus';
import FlaggedMsg, { FlagTypes } from '../flaggedMsg';
import Translate from '../localization/localize';
import Scrim from '../scrim';
import { KFLButton } from '@kamstrup/kamstrup-frontend-library';
import { msgRetryBtn } from '../../../core/localization/messages';

type MoreLogsType = {
  status: CallStatus;
  msgLoader?: MessageType;
  msgMoreBtn?: MessageType;
  getMoreLogs?: () => void;
  hasAllLogs: () => boolean;
};
const MoreLogs: React.FC<MoreLogsType> = ({
  status,
  msgLoader = msgChecking,
  msgMoreBtn = msgMoreLogsBtn,
  getMoreLogs = () => {},
  hasAllLogs,
}) => {
  const showLoadMore = !status.isFetching && !hasAllLogs();

  if (hasError(status))
    return <>
      <FlaggedMsg label={status.errorMsg} type={FlagTypes.Error} />
      <KFLButton variant="borderless" onClick={getMoreLogs}>
          <Translate message={msgRetryBtn} />
      </KFLButton>
    </>;

  return (
    <Scrim isActive={status.isFetching} label={msgLoader} iconSize={16}>
      {showLoadMore ? (
        <KFLButton variant="borderless" onClick={getMoreLogs}>
          <Translate message={msgMoreBtn} />
        </KFLButton>
      ) : (
        <></>
      )}
    </Scrim>
  );
};

export default MoreLogs;
